import { coerceArray } from '@angular/cdk/coercion';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

@Component({
  selector: 'app-confirmation-modal-popup',
  templateUrl: './confirmation-modal-popup.component.html',
  styleUrls: ['./confirmation-modal-popup.component.css']
})
export class ConfirmationModalPopupComponent implements OnInit {
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  @Output() callOnNegativeBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() modalTitle: string;
  @Input() modalMessage: string | SafeHtml | null | undefined;
  @Input() popupPropertieList: any;
  @Input() showByDefault: boolean = true;

  rootScopeData: RootScopeDeclare;
  isRtl: boolean;
  constructor(private rootScopeService: RootScopeService, private sanitizer: DomSanitizer) {
    this.getRootScopeData();
  }

  ngOnInit() {
    if(this.popupPropertieList?.message) this.popupPropertieList.message = coerceArray(this.popupPropertieList.message);
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  onNegativeButtonClick(): void {
    this.callOnNegativeBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    this.callOnPositiveBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

  async show(isAutoClose: boolean) {
    this.showByDefault = true;
    return new Promise((resolve) => {
      var subs1 = this.callOnNegativeBtnClick.subscribe(() => {
        if(isAutoClose) this.showByDefault = false;
        subs1.unsubscribe();
        resolve(-1);
      });
      var subs2 = this.callOnPositiveBtnClick.subscribe(() => {
        if(isAutoClose) this.showByDefault = false;
        subs2.unsubscribe();
        resolve(1);
      });
    });
  }
}
